import { get, patch } from './APIHelper';

export const getMySubscriptions = async () => {
  return get('subscription/me');
};

export const manageMySubscription = async (subscriptionId, cancel) => {
  return patch('subscription/manage', { subscriptionId, cancel });
};
